<script lang="ts" setup>
import {UserInfo} from "@/common/utils/auth";
import TeacherNavBar from "@/components/teacher/common/TeacherNavBar.vue";
import SentryContext from "~components/util/SentryContext.vue"

defineProps<{
  sentryContext: Record<string, unknown>
  user: UserInfo | null
}>()
</script>

<template>
  <div class="inertia-page">
    <header
      id="header"
      class="navbar bg-primary navbar-expand-lg navbar-end navbar-absolute-top navbar-dark navbar-show-hide fixed-top top-0"
    >
      <TeacherNavBar v-if="user" :user="user"/>
    </header>
    <SentryContext :context="sentryContext"/>
    <slot/>
  </div>
</template>
